import { UploadFail } from 'reactApp/modules/uploading/fails/UploadFail';

export class RetryUploadFileFail extends UploadFail {}
